import {
  LayoutDashboard, FileText, FileInput, TrendingDown, Package, Factory, User, Wallet, FolderKanban, BarChart3, Puzzle, ShoppingCart, CreditCard, LifeBuoy, Settings,
  ShoppingBag, Truck, Banknote, UserCheck, Megaphone, Receipt, ClipboardList, FlaskConical, Workflow, Warehouse, MapPin, Landmark, ScrollText, Radio, FileCheck2, LineChart,
  ListTree, Repeat, BellRing, Globe, CalendarDays, BookOpen, ShieldCheck, Users, Upload, Store, Mail, Printer, Boxes, Wrench, Tags, Layers, PackagePlus, SlidersHorizontal, Box,
} from "lucide-react";

// KolayBi düzeni: sol menüde modüller, sayfanın üstünde modülün yatay alt sekmeleri
export const MODULLER = [
  { key: "anasayfa", title: "Anasayfa", icon: LayoutDashboard, tabs: [{ to: "/", label: "Anasayfa", icon: LayoutDashboard }] },
  { key: "satis", title: "Satış Yönetimi", icon: FileText, tabs: [
    { to: "/satis-faturalari", label: "Satış Faturaları", icon: FileText, perm: "fatura:read" },
    { to: "/sevkiyat", label: "Satış İrsaliyeleri", icon: Truck, perm: "sevkiyat:read" },
    { to: "/siparisler", label: "Alınan Siparişler", icon: ShoppingCart, perm: "siparis:read" },
    { to: "/satis/teklifler", label: "Satış Proformaları/Teklifler", icon: FileText, perm: "siparis:read" },
    { to: "/satis/tekrarli", label: "Tekrarlı Satış İşlemleri", icon: Repeat, perm: "fatura:read" },
  ] },
  { key: "satinalma", title: "Satın Alma Yönetimi", icon: FileInput, tabs: [
    { to: "/alis-faturalari", label: "Alış Faturaları", icon: Receipt, perm: "fatura:read" },
    { to: "/satinalma", label: "Verilen Siparişler", icon: ShoppingBag, perm: "satinalma:read" },
    { to: "/tedarikci-odemeleri", label: "Tedarikçi Ödemeleri", icon: Banknote, perm: "odeme:read" },
  ] },
  { key: "gider", title: "Genel Gider Yönetimi", icon: TrendingDown, kok: ["/giderler"], tabs: [
    { to: "/giderler", label: "Genel Giderler", icon: TrendingDown, perm: "gider:read" },
    { to: "/giderler/tipler", label: "Genel Gider Tipleri", icon: ListTree, perm: "gider:read" },
    { to: "/giderler/tekrarli", label: "Tekrarlı Genel Giderler", icon: Repeat, perm: "gider:read" },
  ] },
  { key: "urun", title: "Ürünler ve Hizmetler", icon: Package, tabs: [
    { to: "/urunler", label: "Tümü", icon: Package },
    { to: "/urun-listesi", label: "Ürünler", icon: Boxes },
    { to: "/hizmetler", label: "Hizmetler", icon: Wrench },
    { to: "/fiyat-listeleri", label: "Fiyat Listeleri", icon: Tags },
    { to: "/lokasyonlar", label: "Depolar", icon: MapPin },
    { to: "/depo", label: "Depo Takip", icon: Warehouse, perm: "stok:read" },
    { to: "/depo-simulasyon", label: "Depo Simülasyonu", icon: Box, perm: "stok:read" },
    { to: "/varyantlar", label: "Varyantlar", icon: Layers },
    { to: "/toplu-stok", label: "Toplu Stok Güncelleme", icon: PackagePlus, perm: "stok:write" },
    { to: "/toplu-urun", label: "Toplu Ürün Güncelleme", icon: SlidersHorizontal },
  ] },
  { key: "uretim", title: "Üretim", icon: Factory, tabs: [
    { to: "/uretim", label: "Planlama", icon: ClipboardList, perm: "uretim:read" },
    { to: "/is-emirleri", label: "İş Emirleri", icon: ListTree, perm: "uretim:read" },
    { to: "/islerim", label: "İşlerim", icon: Factory, perm: "uretim:islem" },
    { to: "/uretim/raporlar", label: "Üretim Raporları", icon: BarChart3, perm: "uretim:plan" },
    { to: "/uretim/kalip-kapasite", label: "Kalıp & Kapasite", icon: CalendarDays, perm: "uretim:read" },
    { to: "/receteler", label: "Reçeteler & Maliyet", icon: FlaskConical, perm: "recete:read" },
    { to: "/istasyonlar", label: "İstasyon Akışı", icon: Workflow },
    { to: "/operasyonlar", label: "Operasyonlar", icon: Workflow },
  ] },
  { key: "cari", title: "Cari Hesaplar", icon: User, tabs: [
    { to: "/cariler", label: "Genel Cariler", icon: User, perm: "cari:read" },
    { to: "/bayi-basvurulari", label: "Bayi Başvuruları", icon: UserCheck, perm: "cari:write" },
    { to: "/bayi-duyurulari", label: "Bayi Duyuruları", icon: Megaphone, perm: "cari:write" },
    { to: "/cari-mutabakatlar", label: "Mutabakatlar", icon: UserCheck, perm: "cari:read" },
  ] },
  { key: "finans", title: "Finans", icon: Wallet, kok: ["/finans/"], tabs: [
    { to: "/finans/banka", label: "Banka Hesapları", icon: Landmark, perm: "hesap:read" },
    { to: "/finans/kasa", label: "Kasalar", icon: Wallet, perm: "hesap:read" },
    { to: "/finans/kredi-karti", label: "Kredi Kartları", icon: CreditCard, perm: "hesap:read" },
    { to: "/banka-hareketleri", label: "Online Banka Hesapları", icon: Radio, perm: "hesap:read" },
    { to: "/finans/cekler", label: "Çekler", icon: FileText, perm: "tahsilat:read" },
    { to: "/finans/senetler", label: "Senetler", icon: ScrollText, perm: "tahsilat:read" },
    { to: "/tahsilatlar", label: "Tahsilatlar", icon: Wallet, perm: "tahsilat:read" },
    { to: "/banka-hesaplari", label: "Hesap Özeti & Virman", icon: Landmark, perm: "hesap:read" },
    { to: "/nakit-akis", label: "Nakit Akışı", icon: LineChart, perm: "odeme:read" },
    { to: "/banka-mutabakat", label: "Banka Mutabakatı", icon: FileCheck2, perm: "hesap:read" },
  ] },
  { key: "proje", title: "Projeler", icon: FolderKanban, kok: ["/projeler"], tabs: [{ to: "/projeler", label: "Projeler", icon: FolderKanban, perm: "proje:read" }] },
  { key: "rapor", title: "Raporlar", icon: BarChart3, tabs: [
    { to: "/raporlar", label: "Raporlar", icon: BarChart3 },
    { to: "/gunluk-ozet", label: "Günlük Özet", icon: BellRing, perm: "ozet:read" },
  ] },
  { key: "ek", title: "Ek Özellikler", icon: Puzzle, tabs: [{ to: "/ek-ozellikler", label: "Ek Özellikler", icon: Puzzle }] },
  { key: "eticaret", title: "E-Ticaret", icon: ShoppingCart, tabs: [
    { to: "/e-ticaret", label: "E-Ticaret Entegrasyonları", icon: Store },
    { to: "/site-yonetimi", label: "Web Sitesi", icon: Globe, admin: true },
  ] },
  { key: "abonelik", title: "Abonelik", icon: CreditCard, tabs: [{ to: "/abonelik", label: "Abonelik", icon: CreditCard }] },
  { key: "destek", title: "Destek", icon: LifeBuoy, tabs: [
    { to: "/destek", label: "Destek Talepleri", icon: LifeBuoy },
    { to: "/destek/randevular", label: "Randevular", icon: CalendarDays },
    { to: "/yardim", label: "Yardım / SSS", icon: BookOpen },
    { to: "/satici-paneli", label: "Satıcı Paneli", icon: ShieldCheck, satici: true },
  ] },
  { key: "ayarlar", title: "Ayarlar", icon: Settings, tabs: [
    { to: "/ayarlar", label: "Şirket", icon: Settings, admin: true },
    { to: "/ayarlar/e-posta", label: "E-Posta Ayarları", icon: Mail },
    { to: "/ayarlar/siparis", label: "Sipariş Ayarları", icon: Settings, admin: true },
    { to: "/ayarlar/yazdirma-sablonlari", label: "Yazdırma Şablonları", icon: Printer, perm: "sablon:write" },
    { to: "/toplu-aktarim", label: "İçe Aktar", icon: Upload, admin: true },
  ] },
];

const eslesir = (to, path) => (to === "/" ? path === "/" : path === to || path.startsWith(`${to}/`));

export const modulBul = (path) => {
  let en = null;
  let uz = -1;
  MODULLER.forEach((m) => {
    [...m.tabs.map((t) => t.to), ...(m.kok || [])].forEach((p) => {
      if ((eslesir(p, path) || (p.endsWith("/") && path.startsWith(p))) && p.length > uz) { en = m; uz = p.length; }
    });
  });
  return en;
};
